import { useQuery } from 'react-query';
import { useFormContext } from 'react-hook-form';
import { getBrands } from 'api/services/mediaPlanning/mediaPlanning';
import { SelectChangeEvent } from '@mui/material';
import { useParams } from 'react-router-dom';
import usePlanStore from '../../../../../../store/planStore';
import { FormSelect } from '../../../common/FormSelect/FormSelect';

export interface Brand {
  id: number | string;
  title: string;
}

export default function BrandSelect() {
  const { control } = useFormContext<{
    brand: Brand;
  }>();

  const { id } = useParams();

  const { generalInfoState, setGeneralInfoState } = usePlanStore((state) => ({
    generalInfoState: state.generalInfoState,
    setGeneralInfoState: state.setGeneralInfoState,
  }));

  const { data: brandsResponse, isFetching } = useQuery(
    ['brands', generalInfoState.division],
    () => getBrands(generalInfoState.division),
    {
      enabled: !!generalInfoState.division,
    }
  );

  return (
    <FormSelect
      name="brand"
      control={control}
      label="Brand"
      value={generalInfoState.brand}
      options={brandsResponse?.data.brands || []}
      isDisabled={isFetching || !generalInfoState.division || !!id}
      isLoading={isFetching}
      onChange={(event: SelectChangeEvent<unknown>) => {
        setGeneralInfoState({
          brand: event.target.value as string,
          category: undefined,
        });
      }}
    />
  );
}
